import { BaseModel } from './baseModel';
import type { CellStyle } from './cellStyle';
import type { RichText } from './richText';
import { type StoredStyle, type StyleToMerge, mergeStyles } from './types';
import type { Vector2 } from '@/utils/vec';

export class Cell extends BaseModel {
  constructor(
    public readonly pos: Vector2,
    public readonly value: RichText | string = '',
    public readonly style: StoredStyle<CellStyle> = {},
  ) {
    super();
  }

  public withValue(value: RichText | string): Cell {
    return new Cell(this.pos, value, this.style);
  }

  public withDefaultOrValue(value: RichText | string): Cell {
    return this.value ? this : this.withValue(value);
  }

  public withStyle(style: StyleToMerge<CellStyle>): Cell {
    return new Cell(this.pos, this.value, mergeStyles(this.style, style));
  }

  public canRemove(): boolean {
    return !this.value && Object.keys(this.style).length === 0;
  }
}
